import { Grid, Typography } from "@mui/material";
import { useMessage } from "hooks/intl";
import { Fragment } from "react";
import { SegmentFEData } from "types/segments";
import { BoxElement } from "../SegmentForm/SegmentConditions/BoxElement";
import { getComponent, segmentConditions } from "../SegmentForm/SegmentForm";
import { useStyles } from "./SingleSegment.styles";

export const Rules = ({ segmentData }: { segmentData: SegmentFEData }) => {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <>
      <Grid container className={classes.detailsWrapper}>
        <Grid className={classes.gridChild} item xs={12}>
          <Typography className={classes.header}>
            {message({ id: "rules" })}
          </Typography>
          {segmentData?.parts.map((part, index) => (
            <div key={index}>
              <Typography className={classes.ruleHeader}>
                {`${message({ id: "rule" })} ${index + 1}`}
              </Typography>
              {part.criteria.map((criterion, criterionId) => {
                const conditionTypeLabel =
                  segmentConditions.find(
                    (condition) =>
                      criterion.type &&
                      condition.component === getComponent(criterion.type),
                  )?.label || "";

                const formField = `parts.${index}.criteria.${criterionId}`;
                const conditionCirteria = segmentData?.parts?.[index]?.criteria;
                const isOrOperator =
                  criterionId + 1 < conditionCirteria?.length;
                const Condition =
                  criterion.type && getComponent(criterion.type);

                return (
                  <Fragment key={`${index}${criterionId}`}>
                    <div className={classes.criterion}>
                      {`${criterionId + 1}.`}
                      <BoxElement
                        content={message({
                          id: conditionTypeLabel,
                        })}
                      />
                      {Condition && (
                        <Condition
                          formField={formField}
                          values={segmentData}
                          readOnly={true}
                          status=""
                          setFieldValue={() => {}}
                        />
                      )}
                    </div>
                    {isOrOperator && (
                      <Typography className={classes.operator}>
                        {message({ id: "or" })}
                      </Typography>
                    )}
                  </Fragment>
                );
              })}
            </div>
          ))}
        </Grid>
      </Grid>
    </>
  );
};
